class BaseObject {
  start() {}
  update(deltaTime) {}
  dispose() {}
}
export default BaseObject;
